// TODO: Треба перейментувати на selectorsIds чи щось таке

// Для тих data-testid де ми точно знаємо що вони на сторінку будуть унікальні
export const COMMON_SELECTORS_IDS = {
  confirmationModal: {
    modal: 'commonConfirmationModal',
    confirmButton: 'commonConfirmationModalConfirmButton',
    cancelButton: 'commonConfirmationModalCancelButton',
  },
  bookingPageIsLoading: 'bookingPageIsLoading',
  smallSpinner: 'commonSmallSpinner',
}

export const CLIENT_SELECTORS_IDS = {
  firstName: 'clientFirstName',
  firstNameRequiredError: 'clientFirstNameRequiredError',
  lastName: 'clientLastName',
  middleName: 'clientMiddleName',
  maximumDebt: 'clientMaximumDebt',
  phone: 'clientPhone',
  phoneRequiredError: 'clientPhoneRequiredError',
  createButton: 'clientCreateButton',
  modal: 'clientModal',
  saveButton: 'clientSaveButton',
  list: 'clientList',
  archiveList: 'clientArchiveList',
  goToArchiveButton: 'clientGoToArchiveButton',
  goBackFromArchiveButton: 'clientGoBackFromArchiveButton',
  archiveButton: 'clientArchiveButton',
  modalOptionTab: 'clientModalOptionTab',
  leadFilterSelect: 'clientLeadFilterSelect',
  involvementFilterSelect: 'clientInvolvementFilterSelect',
  restoreButton: 'clientRestoreButton',
  tag: 'clientTag',
}

export const ACCOUNT_SELECTORS_IDS = {
  createButton: 'accountButton',
  modal: 'accountModal',
  name: 'accountName',
  saveButton: 'accountSaveButton',
  setAsDefaultButton: 'accountSetAsDefaultButton',
  list: 'accountListContainer',
  withdrawalSwitch: 'accountWithdrawalSwitch',
  closeButton: 'accountCloseButton',
  forPaymentsSelect: 'accountForPaymentsSelect',
  forPaymentsSelectList: 'accountForPaymentsSelectList',
}

export const EMPLOYEE_SELECTORS_IDS = {
  createButton: 'employeeCreateButton',
  goToArchiveButton: 'employeeGoToArchiveButton',
  modal: 'employeeModal',
  firstName: 'employeeFirstName',
  firstNameRequiredError: 'employeeFirstNameRequiredError',
  lastName: 'employeeLastName',
  lastNameRequiredError: 'employeeLastNameRequiredError',
  scheduleSelect: 'employeeScheduleSelect',
  scheduleSelectRequiredError: 'employeeScheduleSelectRequiredError',
  scheduleSelectList: 'employeeScheduleSelectList',
  groupSelect: 'employeeGroupSelect',
  groupSelectRequiredError: 'employeeGroupSelectRequiredError',
  groupSelectList: 'employeeGroupSelectList',
  datePicker: 'employeeDatePicker',
  datePickerRequiredError: 'employeeDatePickerRequiredError',
  saveButton: 'employeeSaveButton',
  scheduleTypeRadioButtons: 'employeeScheduleTypeRadioButtons',
  treeMenu: 'employeeTreeMenu',
  groupCreateButton: 'employeeGroupCreateButton',
  groupModal: 'employeeGroupModal',
  groupName: 'employeeGroupName',
  groupSaveButton: 'employeeGroupSaveButton',
  roleSelectList: 'employeeRoleSelectList',
  roleSelect: 'employeeRoleSelect',
  hideEmptyGroupSwitch: 'employeeHideEmptyGroupSwitch',
  middleName: 'employeeMiddleName',
  ownerRoleInput: 'employeeOwnerRoleInput',
  groupCloseButton: 'employeeGroupCloseButton',
  scheduleTab: 'employeeScheduleTab',
  closeButton: 'employeeCloseButton',
  stopScheduleButton: 'employeeStopScheduleButton',
  stopScheduleModal: 'employeeStopScheduleModal',
  submitStopScheduleButton: 'employeeSubmitStopScheduleButton',
  archiveButton: 'employeeArchiveButton',
}

export const LOCATION_SELECTORS_IDS = {
  treeMenu: 'locationTreeMenu',
  editButton: 'locationEditButton',
  groupCreateButton: 'locationGroupCreateButton',
  groupModal: 'locationGroupModal',
  groupName: 'locationGroupName',
  groupSaveButton: 'locationGroupSaveButton',
  createButton: 'locationCreateButton',
  modal: 'locationModal',
  name: 'locationName',
  saveButton: 'locationSaveButton',
}

export const PRODUCT_SELECTORS_IDS = {
  treeMenu: 'productTreeMenu',
  createButton: 'productCreateButton',
  modal: 'productModal',
  name: 'productName',
  nameRequiredError: 'productNameRequiredError',
  costPrice: 'productCostPrice',
  costPriceRequiredError: 'productCostPriceRequiredError',
  price: 'productPrice',
  priceRequiredError: 'productPriceRequiredError',
  saveButton: 'productSaveButton',
  typeRadioButtons: 'productTypeRadioButtons',
  typeRadioButtonsRequiredError: 'productTypeRadioButtonsRequiredError',
  groupCreateButton: 'productGroupCreateButton',
  groupModal: 'productGroupModal',
  groupName: 'productGroupName',
  groupNameRequiredError: 'productGroupNameRequiredError',
  groupDescription: 'productGroupDescription',
  groupSaveButton: 'productGroupSaveButton',
  barcode: 'productBarcode',
  dublicateButton: 'productDublicateButton',
}

export const SERVICE_SELECTORS_IDS = {
  treeMenu: 'serviceTreeMenu',
  editButton: 'serviceEditButton',
  groupCreateButton: 'serviceGroupCreateButton',
  groupModal: 'serviceGroupModal',
  groupName: 'serviceGroupName',
  groupNameRequiredError: 'serviceGroupNameRequiredError',
  groupDescription: 'serviceGroupDescription',
  groupSaveButton: 'serviceGroupSaveButton',
  createButton: 'serviceCreateButton',
  modal: 'serviceModal',
  name: 'serviceName',
  nameRequiredError: 'serviceNameRequiredError',
  price: 'servicePrice',
  priceRequiredError: 'servicePriceRequiredError',
  costPrice: 'serviceCostPrice',
  duration: 'serviceDuration',
  durationRequiredError: 'serviceDurationRequiredError',
  saveButton: 'serviceSaveButton',
  goToArchiveButton: 'serviceGoToArchiveButton',
  typeSelect: 'serviceForPaymentsSelect',
  typeSelectRequiredError: 'serviceForPaymentsSelectRequiredError',
  typeSelectList: 'serviceForPaymentsSelectList',
  locationTreeSelect: 'serviceLocationTreeSelect',
  locationTreeSelectRequiredError: 'serviceLocationTreeSelectRequiredError',
  employeeTreeSelect: 'serviceEmployeeTreeSelect',
  dublicateButton: 'serviceDublicateButton',
}

export const GIFT_CARD_IDS = {
  modal: 'giftCardModal',
  name: 'giftCardName',
  price: 'giftCardPrice',
  cardPeriod: 'giftCardPeriod',
  saveButton: 'giftCardSaveButton',
  createButton: 'giftCardCreateButton',
  list: 'giftCardListContainer',
  priceRequiredError: 'productPriceRequiredError',
  cardPeriodRequiredError: 'giftCardCardPeriodRequiredError',
}

export const FINANCES_IDS = {
  addRevenueButton: 'addRevenueButton',
  addRevenueModal: 'addRevenueModal',
  addRevenueAmount: 'addRevenueAmount',
  addRevenueAddButton: 'addRevenueAddButton',
  list: 'financesListContainer',
  addToClientAccount: 'addToClientAccount',
  addToClientAccountModal: 'addToClientAccountModal',
  addToClientAccountAmount: 'addToClientAccountAmount',
  addToClientAccountAddButton: 'addToClientAccountAddButton',
  revenueReasonEditButton: 'revenueReasonEditButton',
  revenueReasonSelect: 'revenueReasonSelect',
  addExpenseButton: 'addExpenseButton',
  addExpenseModal: 'addExpenseModal',
  addExpenseAmount: 'addExpenseAmount',
  addExpenseAddButton: 'addExpenseAddButton',
  expenseReasonEditButton: 'expenseReasonEditButton',
  expenseReasonSelect: 'expenseReasonSelect',
}

export const REVENUE_REASON_IDS = {
  modal: 'revenueReasonModal',
  addButton: 'revenueReasonAddButton',
  saveButton: 'revenueReasonSaveButton',
}

export const EXPENSE_REASON_IDS = {
  modal: 'expenseReasonModal',
  addButton: 'expenseReasonAddButton',
  saveButton: 'expenseReasonSaveButton',
}

export const SUBSCRIPTION_IDS = {
  modal: 'subscriptionModal',
  name: 'subscriptionName',
  cardPeriod: 'subscriptionPeriod',
  servicePrice: 'subscriptionServicePrice',
  serviceQuantity: 'serviceQuantity',
  servicePriceArrow: 'subscriptionServiceArrowPrice',
  saveButton: 'subscriptionSaveButton',
  createButton: 'subscriptionCreateButton',
  list: 'subscriptionListContainer',
  serviceTreeSelect: 'serviceTreeSelect',
  serviceTreeSelectList: 'serviceTreeSelectList',
  dublicateButton: 'subscriptionDublicateButton',
  typeSelect: 'subscriptionTypeSelect',
  price: 'subscriptionPrice',
  sharedQuantity: 'subscriptionSharedQuantity',
}

export const TAG_IDS = {
  modal: 'tagModal',
  name: 'tagName',
  saveButton: 'tagSaveButton',
  createButton: 'tagCreateButton',
  list: 'tagListContainer',
  goToArchiveButton: 'tagGoToArchiveButton',
  archiveButton: 'tagArchiveButton',
  select: 'tagSelect',
  selectList: 'tagSelectList',
  description: 'tagDescription',
  nameRequiredError: 'tagNameRequiredError',
}

export const SCHEDULE_IDS = {
  modal: 'scheduleModal',
  name: 'scheduleName',
  saveButton: 'scheduleSaveButton',
  createButton: 'scheduleCreateButton',
  calendar: 'scheduleCalendarContainer',
  templatesList: 'scheduleTemplatesListContainer',
  goToScheduleTemplatesButton: 'scheduleGoToScheduleTemplatesButton',
  typeHorizontalButtons: 'scheduleTypeHorizontalButtons',
}

export const STORAGE_IDS = {
  modal: 'storageModal',
  name: 'storageName',
  saveButton: 'storageSaveButton',
  createButton: 'storageCreateButton',
  treeMenu: 'storageTreeMenu',
  setAsDefaultButton: 'storageSetAsDefaultButton',
  closeButton: 'storageCloseButton',
  description: 'storageDescription',
  nameRequiredError: 'storageNameRequiredError',
}

export const MOVEMENT_IDS = {
  arrivalButton: 'movementArrivalButton',
  chooseProductsModal: 'movementChooseProductsModal',
  productTreeMenu: 'movementProductTreeMenu',
  productTreeItem: 'movementProductTreeItem',
  chooseButton: 'movementChooseButton',
  arrivalModal: 'movementArrivalModal',
  supplierSelect: 'movementSupplierSelect',
  supplierSelectList: 'movementSupplierSelectList',
  storageSelect: 'movementStorageSelect',
  storageSelectList: 'movementStorageSelectList',
  movementNumber: 'movementNumber',
  discount: 'movementDiscount',
  description: 'movementDescription',
  transportCosts: 'movementTransportCosts',
  accountSelect: 'movementAccountSelect',
  amount: 'movementAmount',
  completed: 'movementCompleted',
  payImmediately: 'movementPayImmediately',
  submitButton: 'movementSubmitButton',
  list: 'movementListContainer',
  productQuantity: 'movementProductQuantity',
  productPrice: 'movementProductPrice',
  // Posting Movement IDs
  postingButton: 'movementPostingButton',
  postingModal: 'movementPostingModal',
  postingSubmitButton: 'movementPostingSubmitButton',
  // Product creation in movement dialog
  createProductButton: 'movementCreateProductButton',
}
